import React, { useEffect, useRef, useState } from "react";

import classNames from "classnames";
import lottie from "lottie-web";
import PropTypes from "prop-types";

import "./lottiePlayer.scss";

const LottiePlayer = ({
  autoplay = true,
  className = undefined,
  loop = true,
  path,
  renderAsOverlay = false,
  styleOptions = {},
}) => {
  const animationContainer = useRef(null);
  const animation = useRef(null);

  const [playerVisible, setPlayerVisible] = useState(path.length > 0);

  useEffect(() => {
    if (!animationContainer.current) {
      return () => {};
    }

    animation.current = lottie.loadAnimation({
      autoplay,
      container: animationContainer.current,
      loop,
      path,
      playerVisible: false,
      renderer: "svg",
    });

    animation.current?.addEventListener("complete", () => {
      if (renderAsOverlay) {
        setPlayerVisible(false);
      }

      if (!autoplay) {
        animation.current.stop();
      }
    });

    if (!autoplay) {
      animationContainer.current.addEventListener("mouseenter", () => {
        if (animation.current) {
          animation.current.play(); // Animation abspielen
        }
      });
    }

    return () => {
      if (renderAsOverlay) {
        animation.current?.removeEventListener("complete");
        animation.current?.destroy();
      }
    };
  }, []);

  if (playerVisible) {
    return (
      <div
        className={classNames(
          "lottie-player",
          className,
          { overlay: renderAsOverlay },
        )}
        ref={animationContainer}
        style={styleOptions}
      />
    );
  }

  return null;
};

LottiePlayer.propTypes = {
  autoplay: PropTypes.bool,
  className: PropTypes.string,
  loop: PropTypes.bool,
  path: PropTypes.string.isRequired,
  renderAsOverlay: PropTypes.bool,
  styleOptions: PropTypes.oneOfType([PropTypes.object]),
};

export default LottiePlayer;
